const extractPatientsFromClient = (client: PatientChartResponseEntry) =>
  client.couple_members && client.couple_members.length > 0
    ? client.couple_members
    : [client.patient];

const getPossibleNamesLowerCase = (patient: PatientChartContact) =>
  [patient.preferred_first_name, patient.first_name, patient.last_name]
    .filter((name) => name && name.length)
    .map((name) => name?.toLowerCase()) as string[];

const searchClientsByName = (
  clients: PatientChartResponseEntry[],
  query: string,
) => {
  if (query.trim().length === 0) {
    return clients;
  }

  const queryWordsLowerCase = query
    .split(" ")
    .map((word) => word.toLowerCase());

  return clients.filter((client) => {
    const possibleNames = extractPatientsFromClient(client).flatMap(
      getPossibleNamesLowerCase,
    );
    return queryWordsLowerCase.every((word) =>
      possibleNames.some((name) => name.includes(word)),
    );
  });
};

export default searchClientsByName;
